export const mutations = {
    
    STORE_IMPORTERS(state, importers) {
        state.importers = importers
    },

    STORE_IMPORTER_UPDATE (state, importerId) {
        let Importer = state.importers.find(function(importer) {
            return importer.id === importerId
        })
        state.systemImporter = Importer
    }
}
export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/importers/mutations.js